module.exports = __webpack_public_path__ + "img/xiangxuegongyuan.50226eeb.png";